<template>
  <div>
    <el-table
      border
      :data="pageMaterialList"
      highlight-current-row
      header-row-class-name="table-header"
    >
      <el-table-column
        label="序号"
        prop="index"
        align="center"
        type="index"
        width="60"
        fixed
      />
      <el-table-column
        label="品目编码"
        align="center"
        min-width="120"
        show-overflow-tooltip
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielCode || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="品目名称"
        align="center"
        min-width="120"
        show-overflow-tooltip
        fixed
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielName || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="数量"
        align="right"
        header-align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.materielNum ? strToThousands(row.materielNum) : ' - ' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="单位"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.unitType || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="参数型号"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielModel || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="品牌/制造商"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.materielBrand || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="
          `${isWuling && !requireTax ? '预算不含税单价' : '预算单价'}（${
            isDollar ? '美元' : '元'
          }）`
        "
        align="right"
        header-align="center"
        :min-width="isWuling ? 160 : 120"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>
            {{
              row.budgetUnitPrice ? strToThousands(row.budgetUnitPrice) : ' - '
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        :label="
          `${isWuling && !requireTax ? '预算不含税总价' : '总价'}（${
            isDollar ? '美元' : '元'
          }）`
        "
        align="right"
        header-align="center"
        :min-width="isWuling ? 160 : 120"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>
            {{ row.totalPrice ? strToThousands(row.totalPrice) : ' - ' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="交货地点"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryAddress || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="交货时间(天)"
        align="center"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="{ row }">
          <span>{{ row.deliveryDay || ' - ' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="报价详情" align="center" min-width="200">
        <el-table-column
          :label="
            `${requireTax ? '含税价' : isWuling ? '不含税单价' : '未含税价'}（${
              isDollar ? '美元' : '元'
            }）`
          "
          align="right"
          header-align="center"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <template v-if="row.offerPrice">
              <span class="text-primary">
                {{ row.offerPrice }} / {{ row.unitType }}
              </span>
            </template>
            <span v-else class="text-primary">-</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="requireTax"
          align="center"
          min-width="100"
          label="税率（%）"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <span class="text-primary">
              {{ row.offerTaxRate ? strToThousands(row.offerTaxRate) : ' - ' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="requireTax"
          align="right"
          header-align="center"
          min-width="150"
          :label="`不含税单价（${isDollar ? '美元' : '元'}）`"
          show-overflow-tooltip
        >
          <template v-slot:default="{ row }">
            <template v-if="row.noRateOfferPrice">
              <span class="text-primary">
                {{
                  row.noRateOfferPrice
                    ? strToThousands(row.noRateOfferPrice)
                    : '-'
                }}
                / {{ row.unitType }}
              </span>
            </template>
            <span v-else class="text-primary">-</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="`报价总金额（${isDollar ? '美元' : '元'}）`"
          align="right"
          header-align="center"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span class="text-primary">
              {{
                row.offerTotalPrice
                  ? strToThousands(row.offerTotalPrice)
                  : ' - '
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="`不含税总价（${isDollar ? '美元' : '元'}）`"
          align="right"
          header-align="center"
          min-width="120"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span class="text-primary">
              {{
                row.noRateTotalPrice
                  ? strToThousands(row.noRateTotalPrice)
                  : ' - '
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="参数型号" align="center" min-width="100">
          <template slot-scope="{ row }">
            <span class="text-primary">
              {{ row.offerMaterielModel || ' - ' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="品牌/制造商" align="center" min-width="100">
          <template slot-scope="{ row }">
            <span class="text-primary">
              {{ row.offerMaterielBrand || ' - ' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="交货时间(天)" align="center" min-width="100">
          <template slot-scope="{ row }">
            <span class="text-primary">
              {{ row.offerDeliveryDay || ' - ' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" min-width="100">
          <template slot-scope="{ row }">
            <span class="text-primary">
              {{ row.offerRemark || ' - ' }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <!--前端模拟分页-->
    <pagination
      v-show="materialList.length > size"
      :total="materialList.length"
      size="small"
      :page.sync="page"
      :limit.sync="size"
    />
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination'

import { strToThousands } from '@/utils/utils'
export default {
  components: { Pagination },
  props: {
    // 是否是五菱发布的项目
    isWuling: {
      type: Boolean,
      default: false
    },

    materialList: {
      type: Array,
      default: () => []
    },

    // 报价是否含税
    requireTax: {
      type: Boolean,
      default: false
    },

    // 是否美元报价
    isDollar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 前端模拟分页变量
      pageMaterialList: [],
      page: 1,
      size: 20
    }
  },

  watch: {
    materialList: {
      handler(val) {
        if (val?.length > 0) {
          this.getPageData()
        }
      },
      deep: true,
      immediate: true
    },

    size(val) {
      this.getPageData()
    },

    page(val) {
      this.getPageData()
    }
  },

  methods: {
    strToThousands,
    /**
     * 前端分页，获取当前页数据
     */
    getPageData() {
      const start = (this.page - 1) * this.size
      const end = start + this.size
      this.pageMaterialList = this.materialList.slice(start, end)
    }
  }
}
</script>
